import React, { FC, SVGProps } from 'react';
import { Asset } from '@clearcover/atlas';
import { stringToTestId } from 'Shared/utils';
import styles from './styles.module.css';

export const AgentActionButton: FC<{
  icon: React.MemoExoticComponent<
    (props: SVGProps<SVGSVGElement>) => JSX.Element
  >;
  onClick(): void;
  label: string;
}> = ({ icon, onClick, label }) => {
  return (
    <button
      className={styles.agentActionButton}
      onClick={onClick}
      data-testid={`congrats-${stringToTestId(label)}-modal-open-button`}
    >
      <div className={styles.iconContainer}>
        <Asset
          icon={icon}
          description={label}
          height={56}
          width={56}
          className={styles.icon}
        />
      </div>
      {label}
    </button>
  );
};
